var formatNumerals = function formatNumerals(a) {
  return function (b) {
    return b.replace(/[0-9]/g, function (b) {
      return a[+b];
    });
  };
};

export default formatNumerals;